import React from 'react';
import { useSpring, animated } from '@react-spring/web';

import { useTabPanelContext } from '../context';
import TabPanel from '../Panel';

interface TabPanelContainerProps {
    children: React.ReactElement<React.ComponentProps<typeof TabPanel>>[];
}

function TabPanelContainer({ children }: TabPanelContainerProps) {
    const { currentTab, tabNames } = useTabPanelContext();
    const [visibleTab, setVisibleTab] = React.useState(currentTab);

    const currentIndex = tabNames.indexOf(currentTab);
    const { x } = useSpring({
        x: -(currentIndex * 100),

        onRest: () => {
            setVisibleTab(currentTab);
        },
    });

    return (
        <animated.div
            style={{
                position: 'relative',
                width: '100%',
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                willChange: 'transform',
                transform: x.to((value) => `translateX(${value}%)`),
            }}>
            {React.Children.map(children, (child) =>
                React.isValidElement(child) && child.type === TabPanel
                    ? React.cloneElement(child, { visibleTab })
                    : null
            )}
        </animated.div>
    );
}

export default TabPanelContainer;
